module.exports = __webpack_public_path__ + "img/bg10.ba03c75c.png";